var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { mainGradient, colors } from "../../../theme";
var useStyles = makeStyles({
    root: {
        "&:hover": {
            backgroundColor: "transparent"
        }
    },
    icon: {
        borderRadius: 2,
        width: 16,
        height: 16,
        backgroundColor: colors.white,
        border: "solid 0.5px",
        "$root.Mui-focusVisible &": {
            outlineOffset: 2
        },
        "input:hover ~ &": {
            border: "solid 0.5px"
        },
        "input:disabled ~ &": {
            boxShadow: "none",
            background: "#cfcfcf"
        }
    },
    checkedIcon: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: 16,
        height: 16,
        borderRadius: 2,
        backgroundImage: mainGradient,
        "input:hover ~ &": {
            border: "solid 0.5px ".concat(colors.primary)
        },
        "input:disabled ~ &": {
            boxShadow: "none",
            opacity: "0.5"
        }
    },
    smallIcon: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: 14,
        height: 14,
        backgroundColor: colors.white,
        borderRadius: 1,
        "input:hover ~ &": {
            backgroundColor: colors.primary,
            backgroundImage: "none"
        },
        "input:disabled ~ &": {
            boxShadow: "none",
            opacity: "0.5"
        }
    },
    smallIconInside: {
        width: 10,
        height: 10,
        borderRadius: 1,
        backgroundImage: mainGradient,
        "input:hover ~ &": {
            backgroundColor: colors.primary
        }
    }
});
var AppCheckboxButton = function (props) {
    var classes = useStyles();
    return (_jsx(Checkbox, __assign({ className: classes.root, disableRipple: true, checkedIcon: _jsx("span", __assign({ className: classes.checkedIcon }, { children: _jsx("div", __assign({ className: classes.smallIcon }, { children: _jsx("div", { className: classes.smallIconInside }) })) })), icon: _jsx("span", { className: classes.icon }) }, props)));
};
export { AppCheckboxButton };
//# sourceMappingURL=data:application/json;base64,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